module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "root"
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0",
      "top": "0"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom
    }
  }, [_c('gmap-cluster', [_vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: m.id,
      attrs: {
        "label": _vm.firstLetter(m),
        "position": {
          lat: m.latitude,
          lng: m.longitude
        },
        "clickable": true,
        "draggable": false,
        "icon": _vm.getIcon(m)
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccd5d9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Places.vue
// module id = 449
// module chunks = 1